import React from "react";
import { Wallet, Landmark, CreditCard } from "lucide-react";
import { fmt } from "@/lib/finance";

/* Global Liquidity Dashboard — Cash & Liquidity Hub summary shown at the
   top of /finance for Founder/Admin (whoever can see `liquidity`, fetched
   by the parent page). Extracted from Finance.jsx (Feb 2026 split) so the
   page file stays focused on data-loading + tab orchestration. */
export default function LiquidityDashboard({ liquidity }) {
  if (!liquidity) return null;
  return (
    <div className="card-flat p-4 mb-6" data-testid="liquidity-by-source-widget">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Wallet size={16} className="text-[#F54800]" />
          <div>
            <div className="text-xs text-slate-500">Total Studio Cash <span className="text-slate-400">· statement balances</span></div>
            <div className="font-display text-2xl font-semibold text-slate-900" data-testid="total-studio-cash-value">{fmt(liquidity.total_studio_cash)}</div>
          </div>
        </div>
        <a href="/sources" className="text-[11px] text-[#F54800] hover:underline">Manage sources →</a>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {(liquidity.sources || []).filter((s) => s.is_active).map((s) => (
          <div key={s.id} className="border border-slate-100 rounded-sm p-2.5 bg-slate-50/60" data-testid={`liquidity-source-${s.id}`}>
            <div className="flex items-center gap-1.5 text-[10px] text-slate-500 truncate">
              {s.type === "card" ? <CreditCard size={10} /> : <Landmark size={10} />}{s.name}
            </div>
            <div className="font-mono text-sm font-semibold text-slate-900 mt-0.5">{s.statement_balance === null || s.statement_balance === undefined ? <span className="text-slate-400 font-normal">not entered</span> : fmt(s.statement_balance)}</div>
          </div>
        ))}
        {(liquidity.sources || []).length === 0 && <div className="text-xs text-slate-400 italic col-span-4">No cash sources set up yet.</div>}
      </div>
    </div>
  );
}
